import { OrganisationDto } from '@dhl/mdp-api'
import { convertToTerminalData, type Terminal } from '~/modules/terminals/model'

export const convertToTerminal = (terminalDto: OrganisationDto): Terminal => ({
  ...terminalDto,
  data: convertToTerminalData(terminalDto.data),
})
